import { initAnimations } from './animations.js'

const menuButton = document.querySelector('#menu-button')
const menu = document.querySelector('#site-navigation')
const primaryMenu = document.querySelector('#primary-menu')
const drillTitle = menu?.querySelector('.nav-drill-title')
const backBtn = menu?.querySelector('.nav-back')
const mobileMQ = window.matchMedia('(max-width: 767.98px)')
const masthead = document.querySelector('#masthead')

// Expose the real masthead height so the desktop dropdown panel (position:
// fixed) can sit flush under a header whose height changes per breakpoint.
const setHeaderHeight = () => {
  if (masthead) {
    document.documentElement.style.setProperty(
      '--header-h',
      `${masthead.offsetHeight}px`
    )
  }
}
setHeaderHeight()
window.addEventListener('load', setHeaderHeight)
// Re-measure whenever the masthead's size changes — covers the .has-scrolled
// shrink (including every frame of the logo transition) and window resizes.
if (masthead) {
  new ResizeObserver(setHeaderHeight).observe(masthead)
}

// Stack of <ul.sub-menu> panels currently slid open (mobile drill-down)
let openStack = []

// WP has no data-title — derive a panel's title from its parent menu link.
// The injected .sub-nav-btn is also an <a> and comes first, so exclude it.
const labelFor = (subMenu) => {
  const link = subMenu.parentElement?.querySelector(':scope > a:not(.sub-nav-btn)')
  return link ? link.textContent.trim() : 'Menu'
}

const syncDrill = () => {
  menu.classList.toggle('is-deep', openStack.length > 0)
  const top = openStack.at(-1)
  if (drillTitle) {
    drillTitle.textContent = top ? labelFor(top) : 'Menu'
  }
}

const resetDrill = () => {
  for (const panel of openStack) {
    panel.classList.remove('open')
  }
  for (const chevron of primaryMenu?.querySelectorAll('a.sub-nav-btn[aria-expanded="true"]') ?? []) {
    chevron.setAttribute('aria-expanded', 'false')
  }
  openStack = []
  syncDrill()
}

// === Toggle Main Menu ===
menuButton.addEventListener('click', (e) => {
  e.preventDefault()
  const isOpen = menu.classList.toggle('is-open')
  menuButton.classList.toggle('open-menu', isOpen)
  menuButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
  menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true')
  resetDrill()
})

// === Mobile drill-down: chevron drills in, label navigates ===
// A `nav-not-a-link` parent has no real destination, so tapping its label
// drills into the next level too — the whole row behaves like the chevron.
primaryMenu?.addEventListener('click', (e) => {
  if (!mobileMQ.matches) {
    return
  }
  const trigger = e.target.closest(
    'a.sub-nav-btn, .nav-not-a-link.menu-item-has-children > a:not(.sub-nav-btn)'
  )
  if (!trigger) {
    return
  }
  const li = trigger.closest('.menu-item-has-children')
  const sub = li?.querySelector(':scope > ul.sub-menu')
  if (!sub) {
    return
  }
  e.preventDefault()
  sub.classList.add('open')
  const chevron = li.querySelector(':scope > a.sub-nav-btn')
  chevron?.setAttribute('aria-expanded', 'true')
  openStack.push(sub)
  syncDrill()
})

// === Back one level ===
backBtn?.addEventListener('click', () => {
  const panel = openStack.pop()
  if (panel) {
    panel.classList.remove('open')
    const chevron = panel.parentElement?.querySelector(':scope > a.sub-nav-btn')
    chevron?.setAttribute('aria-expanded', 'false')
  }
  syncDrill()
})

// === GSAP animations (src/js/animations.js) ===
initAnimations()

// === Body scroll class ===
window.addEventListener(
  'scroll',
  () => {
    document.body.classList.toggle('has-scrolled', window.scrollY > 30)
  },
  { passive: true }
)

// === Reset when leaving mobile (matches the 768px CSS breakpoint) ===
window.addEventListener('resize', () => {
  setHeaderHeight()
  if (!mobileMQ.matches) {
    menu.classList.remove('is-open')
    menuButton.classList.remove('open-menu')
    menuButton.setAttribute('aria-expanded', 'false')
    menu.setAttribute('aria-hidden', 'true')
    resetDrill()
  }
})
